import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy'
})
export class FilterByPipe implements PipeTransform {

  transform(arr: Array<any>, prop: any, value: any, equal: boolean = true): any {
    if (arr === undefined || prop === null || value === null) {
      return;
    } else {
      return arr.filter(item => (equal) ? item[prop] === value : item[prop] !== value);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/filter-by-pipe/filter-by.pipe.ts